import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { Empty, Progress } from "antd";
import { useCallback, useState } from "react";
import { useI18n } from "../contexts/i18n.js";
function useTableBulkAction() {
    const { __ } = useI18n();
    const [currentProgress, setCurrentProgress] = useState();
    const [currentSettings, setCurrentSettings] = useState();
    const doBulkAction = useCallback(({ total, title })=>{
        let progress = 0;
        const abortController = new AbortController();
        let bulkDoneResolve;
        const bulkDonePromise = new Promise((resolve)=>bulkDoneResolve = resolve);
        setCurrentProgress(0);
        setCurrentSettings({
            total,
            title,
            abortController
        });
        return [
            ()=>{
                progress++;
                if (progress >= total) {
                    // We are done
                    setCurrentProgress(undefined);
                    setCurrentSettings(undefined);
                    bulkDoneResolve();
                } else {
                    setCurrentProgress(progress);
                }
            },
            abortController.signal,
            bulkDonePromise
        ];
    }, []);
    return [
        doBulkAction,
        typeof currentProgress === "number" && currentSettings ? /*#__PURE__*/ _jsx(Empty, {
            style: {
                clear: "both"
            },
            description: /*#__PURE__*/ _jsx(_Fragment, {
                children: /*#__PURE__*/ _jsx("div", {
                    children: currentSettings.title
                })
            }),
            image: /*#__PURE__*/ _jsx(Progress, {
                type: "circle",
                width: 100,
                percent: +(currentProgress / currentSettings.total * 100).toFixed(0),
                format: (percent)=>/*#__PURE__*/ _jsxs(_Fragment, {
                        children: [
                            percent,
                            " %",
                            /*#__PURE__*/ _jsx("br", {}),
                            /*#__PURE__*/ _jsxs("span", {
                                style: {
                                    fontSize: 10
                                },
                                children: [
                                    currentProgress,
                                    " / ",
                                    currentSettings.total
                                ]
                            })
                        ]
                    })
            }),
            children: /*#__PURE__*/ _jsx("button", {
                className: "button button-primary",
                onClick: ()=>{
                    currentSettings.abortController.abort();
                    setCurrentProgress(undefined);
                    setCurrentSettings(undefined);
                },
                children: __("Cancel")
            })
        }) : undefined
    ];
}
export { useTableBulkAction };
